import * as yup from 'yup';

import { REG_EXP, VM } from 'constants/validation';
import { FIELD_NAMES, sourceAnotherOption, sourceOnlineSchoolOption } from './constants';

export const validateScheme = yup
  .object({
    // Персональная информация
    [FIELD_NAMES.fullname]: yup
      .string()
      .required(VM[5])
      .matches(REG_EXP.ruText_dash_space, VM[47])
      .min(3, VM[5])
      .matches(REG_EXP.firstLastName, VM[6]),
    [FIELD_NAMES.birthday]: yup.string().required(VM[23]).matches(REG_EXP.date, VM[27]),
    [FIELD_NAMES.country]: yup.string().required(VM[45]),
    [FIELD_NAMES.city]: yup
      .string()
      .required(VM[18])
      .matches(REG_EXP.ruText_dash_space, VM[47])
      .min(2, VM[18]),

    // Контактная информация
    [FIELD_NAMES.phone]: yup.string().required(VM[7]).matches(REG_EXP.phone, VM[12]),
    [FIELD_NAMES.email]: yup
      .string()
      .email(VM[3])
      .min(1, VM[13])
      .matches(REG_EXP.email, VM[3])
      .required(VM[13]),
    [FIELD_NAMES.telegram]: yup
      .string()
      .required(VM[29])
      .matches(REG_EXP.telegram, VM[64])
      .min(5, VM[29]),

    // Образование
    [FIELD_NAMES.education]: yup.string().required(VM[49]).min(2, VM[49]),
    [FIELD_NAMES.englishLevel]: yup.string().required(VM[9]),

    // Дополнительная информация
    [FIELD_NAMES.additionalEducation]: yup
      .string()
      .required('Опишите допобразование и навыки')
      .min(2, 'Опишите допобразование и навыки'),
    [FIELD_NAMES.informationSource]: yup.string().required(VM[50]),

    // Дополнительные поля формы
    [FIELD_NAMES.source]: yup.string().when(FIELD_NAMES.informationSource, {
      is: value => value === sourceAnotherOption,
      then: schema =>
        schema
          .required(VM[51])
          .min(5, VM[51])
          .matches(REG_EXP.ruEngText_numbers_dash_space, VM[52]),
      otherwise: schema => schema.notRequired(),
    }),
    [FIELD_NAMES.sourceOnlineSchool]: yup.string().when(FIELD_NAMES.informationSource, {
      is: value => value === sourceOnlineSchoolOption,
      then: schema =>
        schema
          .required(VM[113])
          .min(5, VM[113])
          .matches(REG_EXP.ruEngText_numbers_dash_space, VM[52]),
      otherwise: schema => schema.notRequired(),
    }),
  })
  .required();
